import React from 'react'

export default ComposedComponent => {
  return class extends React.Component {
    state = {
      scrollX: 0,
      scrollY: 0,
    }

    handleScroll() {
      this.setState({
        scrollX: window.scrollX,
        scrollY: window.scrollY,
      })
    }

    componentDidMount() {
      window.addEventListener('scroll', () => {
        this.handleScroll()
      })

      if (window.scrollX !== 0 || window.scrollY !== 0) {
        window.dispatchEvent(new Event('scroll'))
      }
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', () => {
        this.handleScroll()
      })
    }

    render() {
      return <ComposedComponent {...this.props} {...this.state} />
    }
  }
}
